import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import FreeTextEventMappingVM from './FreeTextEventMappingVM';
import { observer } from 'mobx-react';
import FreeTextEventMappingLookup from '../Models/Lookups/FreeTextEventMappingLookup';
import { TextConstants } from '../../../Common/TextConstants';
import ManageFreeTextEventMappingComponent from '../Components/ManageFreeTextEventMappingComponent';
import Loading from '../../../App/Components/Loading/Loading';
import { FreeTextEventMapping } from '../../../AccessControl/Models/Commands/Security/Roles';

@observer
export default class FreeTextEventMappingView extends Views.ViewBase<FreeTextEventMappingVM> {

    constructor(props: unknown) {
        super("Free Text Event Mapping", FreeTextEventMappingVM, props);
    }

    public render() {
        return (
            <div>
                {(this.viewModel.taskRunner.isBusy) && <Loading />}
                {this.viewModel.showManageFreeTextMappingComponent &&
                    <ManageFreeTextEventMappingComponent
                        viewModel={this.viewModel.manageFreeTextMappingComponentVM}
                        onSave={() => this.viewModel.saveFreeTextMapping()}
                        onCancel={() => this.viewModel.cancel()} />
                }
                {!this.viewModel.showManageFreeTextMappingComponent &&
                    <Neo.Card title={TextConstants.Titles.FreeTextEventMapping} className="m-1">
                        <div>
                            {this.viewModel.authorisationService.hasRole(FreeTextEventMapping.AddNew) &&
                                <div className="row pb-3">
                                    <div className="col text-right">
                                        <Neo.Button size="sm" className="btn btn-default" onClick={() => this.viewModel.addNewFreeTextEventMapping()}
                                            variant="primary">
                                            {TextConstants.Buttons.AddFreeTextEventMapping}
                                        </Neo.Button>
                                    </div>
                                </div>
                            }
                            <Neo.Form model={this.viewModel.freeTextEventMappingSearchCriteria} onSubmit={() => this.viewModel.freeTextEventMappingSearchCriteria.meta.searchCriteria.value === "" ? this.viewModel.pageManager.refreshData() : this.viewModel.clearSearch()}>
                                <Neo.FormGroup
                                    suppressLabel={true}
                                    bind={this.viewModel.freeTextEventMappingSearchCriteria.meta.searchCriteria}
                                    placeholder={TextConstants.PlaceHolder.SearchFreeTextEventMappings}
                                    append={
                                        <Neo.Button className="btn-small" isSubmit variant="primary">
                                            <i className={`${this.viewModel.freeTextEventMappingSearchCriteria.meta.searchCriteria.value === "" ? "fa fa-search" : "fa fa-times-circle"}`} />
                                        </Neo.Button>}
                                />
                            </Neo.Form>
                        </div>

                        <Neo.Pager pageManager={this.viewModel.pageManager} pageControlProps={{ pageSizeLabel: "Show: " }} >
                            <div className="horizontalScroll">
                                <NeoGrid.Grid<FreeTextEventMappingLookup> className={"table-striped"}>
                                    {(item, meta) => (
                                        <NeoGrid.RowGroup expandProperty={meta.isExpanded}>
                                            <NeoGrid.Row>
                                                <NeoGrid.Column display={meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker} />
                                                <NeoGrid.Column display={meta.rawGenericSourceTableName} label={TextConstants.Labels.GenericSourceTable} />
                                                <NeoGrid.Column display={meta.sourceFieldName} />
                                                <NeoGrid.Column display={meta.rawSourceFieldIncludes} label={TextConstants.Labels.ValueIncludes} />
                                                <NeoGrid.Column display={meta.rawSourceFieldExcludes} label={TextConstants.Labels.ValueExcludes} />
                                                <NeoGrid.Column display={meta.rawDestinationEventType} label={TextConstants.Labels.DestinationEventType} />
                                                <NeoGrid.Column display={meta.rawDestinationCorporateActionType} label={TextConstants.Labels.DestinationCorporateActionType} />
                                                <NeoGrid.Column display={meta.isPositiveValueInd} label={TextConstants.Labels.PositiveValue} />
                                                {this.viewModel.authorisationService.hasRole(FreeTextEventMapping.Edit) &&
                                                    <NeoGrid.ButtonColumn>
                                                        <Neo.Button
                                                            onClick={() => this.viewModel.editFreeTextEventMapping(item)}
                                                            variant="primary" isOutline className="btn-small">
                                                            <i className="fa fa-edit" />
                                                        </Neo.Button>
                                                    </NeoGrid.ButtonColumn>
                                                }
                                            </NeoGrid.Row>
                                            {item.rawGenericServiceProviderEventKeywords.length > 0 &&
                                                <NeoGrid.ChildRow>
                                                    <NeoGrid.Grid
                                                        items={item.rawGenericServiceProviderEventKeywords}>
                                                        {(child, childMeta) => (
                                                            <NeoGrid.Row>
                                                                <NeoGrid.Column display={childMeta.keyword} />
                                                            </NeoGrid.Row>
                                                        )}
                                                    </NeoGrid.Grid>
                                                </NeoGrid.ChildRow>}
                                        </NeoGrid.RowGroup>
                                    )}
                                </NeoGrid.Grid>
                            </div>
                        </Neo.Pager>

                    </Neo.Card>
                }

            </div>
        );
    }
}